/**
 * 上传图片
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2020/5/6      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react';
import PropTypes from "prop-types";
import {message,Spin} from 'antd';
import { fexWebUploaderConfig } from "@config/upload";
import "./index.less";
// import {searchFileHandle} from "@utils/utils";
let id = Math.floor((Math.random()*10000)+1);

class UploadImg extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            imgList:this.props.defaultList && this.props.defaultList.length?this.props.defaultList:[]
        }
    }

    formatBytes(bytes,decimals) {
        if(bytes == 0) return '0 Byte';
        var k = 1024;
        var dm = decimals + 1 || 3;
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    loading(loading){
        this.setState({
            loading:loading
        });
    }

    init(successFn) {
        let _this = this;
        let props = this.props;
        const WebUploader = window.WebUploader;
        var uploader =  WebUploader.create($.extend({}, fexWebUploaderConfig, {
            pick: {
                id: '#filePicker'+(props.keyName||id),
                // label: `${__getServerLanguage('BenDiShangChuanTuPian')}`,
                multiple: this.props.multiple||false,
            },
            accept: props.accept||{
                title: 'Images',
                extensions: 'gif,jpg,jpeg,bmp,png',
                mimeTypes: 'image/*'
            },
            auto: true,
            fileSingleSizeLimit:props.fileSizeLimit||5 * 1024 * 1024,
            // 上传前不进行压缩
            /*compress: {
                width: 800,
                height: 800,

                // 图片质量，只有type为`image/jpeg`的时候才有效。
                quality: 90,

                // 是否允许放大，如果想要生成小图的时候不失真，此选项应该设置为false.
                allowMagnify: false,

                // 是否允许裁剪。
                crop: false,

                // 是否保留头部meta信息。
                preserveHeaders: true,

                // 如果发现压缩后文件大小比原来还大，则使用原来图片
                // 此属性可能会影响图片自动纠正功能
                noCompressIfLarger: false,

                // 单位字节，如果图片大小小于此值，不会采用压缩。5KB
                compressSize: 1024 * 5
            },*/
            compress:false
        }));

        uploader.onUploadSuccess = function (file, response) {
            successFn && successFn(file, response);
            _this.setState({
                loading:false
            });
        };

        uploader.on('error',function (Error,fileSize) {
            if(Error=='Q_EXCEED_SIZE_LIMIT'||Error=='F_EXCEED_SIZE'){
                message.info(`${__getServerLanguage('ZongWenJianDaXiaoChaoChuXianZhi',_this.formatBytes(props.fileSizeLimit||5 * 1024 * 1024))}`);
            }else if(Error=='Q_TYPE_DENIED'){
                message.info(`${__getServerLanguage('BuZhiChiGaiGeShiShangChuan')}`);
            }else {
                message.info(`${__getServerLanguage('ShangChuanShiBai')}`);
            }
            _this.setState({
                loading:false
            });
        });

        uploader.on('fileQueued', function (p) {
            _this.setState({
                loading:true
            });
        });
        uploader.on('beforeFileQueued', function (file) {
            _this.loading(true);
        });
    }

    componentWillMount(){
    }

    componentDidMount(){
        let _this = this;
        setTimeout(()=>{
          this.init(function (file, response) {
            let imgList = [].concat(_this.state.imgList,{
              url:response.model.url,
              fileId:response.model.id,
              fileExtend:response.model.extend,
              fileName:response.model.realName
            });
            _this.setState({
                loading:false,
              imgList:imgList
            })
            _this.props.onChange(imgList);
          })
        },0);
    }

    delete(index,e){
        e.stopPropagation();
        e.preventDefault();
        let imgList = [].concat(this.state.imgList);
        imgList.splice(index,1);
        this.setState({
            imgList:imgList
        });
        this.props.onChange(imgList);
    }

    clickItem(item,index){
      if(typeof this.props.clickItem == 'function'){
        this.props.clickItem(item,index);
      }
    }

    componentWillReceiveProps(nextProps,nextContext){
        if(this.props.defaultList !== nextProps.defaultList) {
            this.setState({imgList: nextProps.defaultList});
        }
    }


    render(){
        let _this = this;
        let {num,title,showNum,text} = this.props;
        let isDisabled = this.props.disabled || false
        let {imgList=[]} = this.state;
        return (
            <div className="antd-upload-img-wrap">
                {
                    (title||showNum)?
                        <div className="title">
                            {title}
                            {
                                (showNum&&num > 1) ? <span>（{imgList.length}/{num}）</span> : ''
                            }
                        </div>
                        :
                        null
                }
                <span className="antd-upload-img-content">
                    {imgList.map(function (item,index) {
                        return <span className="upload-img" key={index} onClick={_this.clickItem.bind(_this,item,index)}>
                            <img src={item.url+'@!100'} onError={(e)=>{
                                let dom = e.target;
                                dom.src = item.url;
                                dom.onerror = "";
                            }} alt=""/>
                            <div className="close-wrap">
                                <span className="ri-close-line" onClick={_this.delete.bind(_this,index)}></span>
                            </div>
                        </span>;
                    })}
                    <Spin spinning={this.state.loading}>
                        <span className="antd-upload-img-btn"
                              id={"filePicker"+(_this.props.keyName||id)}
                              style={{display:imgList.length<num?'inline-block':'none'}}>
                            <div className="add">+</div>
                            <div>{text}</div>
                                {/*{this.props.multiple?<div>({__getServerLanguage('DuoXuan')})</div>:null}*/}
                        </span>
                    </Spin>
                </span>
            </div>
        )
    }
}

UploadImg.defaultProps = {
    accept:{

    },
    keyName:'',
    multiple:false,//多选
    fileSizeLimit:null,
    num:4, //上传的数量
    showNum:true,//是否展示数量
    text:__getServerLanguage('ShangChuanTuPian'),
    onChange:function () {

    }
}
UploadImg.propTypes = {
    num: PropTypes.number,
    onChange: PropTypes.func
}
export default UploadImg;
